export default __webpack_public_path__ + "dist/media/event-message.0e0d47dd.svg";